import { render, staticRenderFns } from "./USDT-TRC20.vue?vue&type=template&id=d4ca9b9e&scoped=true"
import script from "./USDT-TRC20.vue?vue&type=script&lang=js"
export * from "./USDT-TRC20.vue?vue&type=script&lang=js"
import style0 from "./USDT-TRC20.vue?vue&type=style&index=0&id=d4ca9b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ca9b9e",
  null
  
)

export default component.exports